/** Foundation models the reasoning filter can run on (wireframe list). */
export type ReasoningModel = { id: string; label: string; provider: string }

export const REASONING_MODELS: ReasoningModel[] = [
  { id: 'claude-opus-4-8', label: 'Claude Opus 4.8', provider: 'Anthropic' },
  { id: 'gpt-5', label: 'GPT-5', provider: 'OpenAI' },
  { id: 'gemini-2-5-pro', label: 'Gemini 2.5 Pro', provider: 'Google' },
  { id: 'llama-4', label: 'Llama 4', provider: 'Meta' },
]

export const DEFAULT_REASONING_MODEL = 'claude-opus-4-8'
